import { NavLink } from 'react-router'
import { HomeIcon, PhoneIcon, PlusIcon, UsersIcon, SettingsIcon } from 'lucide-react'
import { cn } from '@/lib/utils'

const items = [
  { to: '/', label: 'Home', icon: HomeIcon, end: true },
  { to: '/calls', label: 'Calls', icon: PhoneIcon },
  { to: '/new', label: 'New call', icon: PlusIcon, primary: true },
  { to: '/contacts', label: 'Contacts', icon: UsersIcon },
  { to: '/settings', label: 'Settings', icon: SettingsIcon },
]

export function MobileNav() {
  return (
    <nav className="flex shrink-0 items-stretch justify-around border-t bg-sidebar pb-[env(safe-area-inset-bottom)] md:hidden">
      {items.map(({ to, label, icon: Icon, end, primary }) => (
        <NavLink
          key={to}
          to={to}
          end={end}
          aria-label={label}
          className={({ isActive }) =>
            cn(
              'flex flex-1 flex-col items-center gap-0.5 py-2 text-[10px] font-medium transition-colors',
              isActive ? 'text-primary' : 'text-muted-foreground',
            )
          }
        >
          {primary ? (
            <span className="flex size-6 items-center justify-center rounded-full bg-primary text-primary-foreground">
              <Icon className="size-4" />
            </span>
          ) : (
            <Icon className="size-5" />
          )}
          {label}
        </NavLink>
      ))}
    </nav>
  )
}
